import React from 'react'
import PropTypes from 'prop-types'
import AdminDashboardBanner from 'components/AdminDashboardBanner'
import UserProgressList from 'components/admin/UserProgressList'
import { BodyWrapper, PageWrapper } from './component.styles'

const HsUserProgress = ({
  isSetup,
  practiceTypeData,
  selectedProgram,
  siteId,
}) => {
  if (!siteId) return null
  return (
    <PageWrapper>
      <BodyWrapper>
        <AdminDashboardBanner selectedProgram={selectedProgram} />
        <UserProgressList
          isSetup={isSetup}
          practiceTypeData={practiceTypeData}
          siteId={siteId}
        />
      </BodyWrapper>
    </PageWrapper>
  )
}

HsUserProgress.propTypes = {
  isSetup: PropTypes.bool,
  practiceTypeData: PropTypes.object,
  selectedProgram: PropTypes.object,
  siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default HsUserProgress
